import { Link } from "react-router-dom";
import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2 round 3: rewritten for Project Explore from the real UI, English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Resetting Your Password",
    intro: "Get back into your account with a new password.",
    steps: [
      <>
        Go to the{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          login page
        </Link>{" "}
        and choose Forgot password?
      </>,
      "Type the email address for your account and choose Submit.",
      "Open the email we send you and follow the link.",
      "Type your new password twice and choose Submit.",
    ],
    tip: "A password needs at least 8 characters, with an uppercase letter, a lowercase letter, a number and a special character.",
  },
  es: {
    title: "Cómo cambiar tu contraseña",
    intro: "Vuelve a entrar a tu cuenta con una contraseña nueva.",
    steps: [
      <>
        Ve a la{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          página para iniciar sesión
        </Link>{" "}
        y elige el enlace para recuperar la contraseña.
      </>,
      "Escribe el correo electrónico de tu cuenta y envíalo.",
      "Abre el correo que te enviamos y sigue el enlace.",
      "Escribe tu contraseña nueva dos veces y envíala.",
    ],
    tip: "La contraseña necesita por lo menos 8 caracteres, con una letra mayúscula, una minúscula, un número y un carácter especial.",
  },
};

export default function ResettingYourPassword() {
  return <HelpArticle text={TEXT} />;
}
